import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import AppContext from '../context/HeaderContext';

const menu_css = {
	height : "100%",
	position : "fixed",
	marginTop : "0px",
	background: "#f2f3f3",
};

function ProfileSideNav() {
	const { user } = useContext(AppContext);

	return (
		<Menu
			vertical
			style={menu_css}
		>
			<Menu.Item
				header
				name="Runs"
				as={NavLink}
				to="/runs"
			>Test Ledger</Menu.Item>

			<Menu.Item header>Profile</Menu.Item>
			<Menu.Item
				name="Info"
				as={NavLink}
				to="/profile/info">
			</Menu.Item>

			{!!user.admin &&
				<Menu.Item
					as={NavLink}
					name="API Keys"
					to="/profile/api-keys"
				/>
}
		</Menu>
	);
}

export default ProfileSideNav;
